export default __webpack_public_path__ + "static/media/admin.c4eb2fb4.svg";